























































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import LaporanSvc from "@/services/LaporanRekapTransaksiBankDarah";
import { OpsiNilai } from "@/types/order_bank_darah";
import {
  RekapTransaksiFilter,
  RekapTransaksiSummary,
  TransaksiBankDarahRow
} from "@/types/transaksi_bank_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

@Component({ components: { VCDateTimePicker, UnitRuangPicker } })
export default class LaporanRekapTransaksiBankDarahPage extends Vue {
  filter: RekapTransaksiFilter = {
    tgl_start: moment().startOf("month").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    jenis_rawat: [],
    unit: null,
    cara_bayar: null,
    pelayanan: null,
    term: null
  };

  rows: TransaksiBankDarahRow[] = [];
  summary: RekapTransaksiSummary | null = null;
  bulanTanpaData: string[] = [];
  bulanTanpaRincian: string[] = [];
  jenisRawatItems: OpsiNilai[] = [];
  pelayananItems: OpsiNilai[] = [];
  caraBayarItems: OpsiNilai[] = [];
  maksBaris = 0;
  loading = false;
  downloading = false;

  readonly headers = [
    { text: "No / Tgl", value: "no_trans", width: "120px" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Unit / Jenis Rawat", value: "unit", sortable: false },
    { text: "Cara Bayar / Dokter", value: "bayar", sortable: false },
    { text: "Pelayanan", value: "items", sortable: false },
    { text: "Nilai", value: "total", align: "end", width: "130px" }
  ];

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  mounted() {
    this.load();
  }

  async load() {
    this.loading = true;
    try {
      const res = await LaporanSvc.list(this.filter);
      this.rows = res.rows || [];
      this.summary = res.summary;
      this.bulanTanpaData = res.bulan_tanpa_data || [];
      this.bulanTanpaRincian = res.bulan_tanpa_rincian || [];
      this.jenisRawatItems = res.jenis_rawat_options;
      this.pelayananItems = res.pelayanan_options;
      this.caraBayarItems = res.cara_bayar_options;
      this.maksBaris = res.maks_baris;
    } catch {
      this.rows = [];
      this.summary = null;
      this.bulanTanpaData = [];
      this.bulanTanpaRincian = [];
    } finally {
      this.loading = false;
    }
  }

  async unduh() {
    this.downloading = true;
    try {
      await LaporanSvc.downloadExcel(this.filter);
    } catch {
      return;
    } finally {
      this.downloading = false;
    }
  }

  tanggal(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD").format("DD-MM-YYYY") : "-";
  }

  angka(val: number): string {
    return new Intl.NumberFormat("id-ID").format(val || 0);
  }

  rupiah(val: number): string {
    return `Rp ${this.angka(val)}`;
  }
}
